import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";
import PdfWrapper from "../components/PdfWrapper.js";
import FillablePdf from "./FillablePdf.js";
import LayoutWrapper from "../components/LayoutWrapper.js";
import MainContainer from "../components/MainContainer.js";
import useGetDocument from "../hooks/api/useGetDocument.js";

var ViewableDocument = function ViewableDocument(_ref) {
  var documentId = _ref.documentId,
      _ref$header = _ref.header,
      Header = _ref$header === void 0 ? function () {
    return null;
  } : _ref$header,
      _ref$banner = _ref.banner,
      Banner = _ref$banner === void 0 ? function () {
    return null;
  } : _ref$banner;

  var _useGetDocument = useGetDocument(documentId),
      documentResource = _useGetDocument.documentResource,
      annotationFields = _useGetDocument.annotationFields;

  return documentResource && annotationFields ? jsx(LayoutWrapper, null, jsx(Header, null), jsx(MainContainer, null, jsx(Banner, null), jsx(PdfWrapper, null, jsx(FillablePdf, {
    pdfFileLink: documentResource.links.file,
    annotationFields: annotationFields,
    viewOnly: true
  })))) : null;
};

ViewableDocument.propTypes = {
  documentId: _pt.string.isRequired,
  children: _pt.node
};
var ViewableDocument$1 = withStores(observer(ViewableDocument));
export default ViewableDocument$1;